export namespace CandidatePersonalDetailsAction {
	export class GetPersonalDetailsTab {
		static readonly type =
			'[Candidate Personal Details Tab] Get Personal Details';
	}

	export class UpdatePersonalDetails {
		static readonly type =
			'[Candidate Personal Details Tab] Update Personal Details';
		constructor(public payload: any) {}
	}
	export class UpdateAddress {
		static readonly type = '[Candidate Personal Details Tab] Update Address';
		constructor(public payload: any) {}
	}
	export class SaveSocialMedia {
		static readonly type = '[Candidate Personal Details Tab] Save Social Media';
		constructor(public payload: any) {}
	}

	export class DeleteSocialMedia {
		static readonly type =
			'[Candidate Personal Details Tab] Delete Social Media';
		constructor(public payload: any) {}
	}

	export class SaveWorkInfo {
		static readonly type = '[Candidate Personal Details Tab] Save Work Info';
		constructor(public payload: any) {}
	}

	export class UpdateProfileImage {
		static readonly type =
			'[Candidate Personal Details Tab] Update Profile Image';
		constructor(public image: string) {}
	}

	export class SyncStatus {
		static readonly type = '[Candidate Personal Details Tab] Sync Status';
	}
}
